import type { Teaser } from "@/components/resources/data/posts.types"
import { SmallTeaser } from "./Teaser"

interface Props {
  teasers: Teaser[]
  className?: string
}

export const TeaserGrid = ({ teasers, className }: Props) => {
  return (
    <ol className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 ${className || ""}`}>
      {teasers?.map((item) => {
        return (
          <li key={item.id ?? item.slug} className="flex">
            <SmallTeaser teaser={item} as="article" />
          </li>
        )
      })}
    </ol>
  )
}
